import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import SessionStore from './stores/SessionStore';
import { getDeviceHash } from './utils/browser';
import { LOCALE_WHITELIST } from './constants/LocaleConstants';
import { fetchResourceBundle } from './utils/i18WebAPIUtils';

const resources = {};

const LanguageDetector = {
  type: 'languageDetector',
  async: true,
  detect: function (callback) {
    const deviceHash = getDeviceHash();
    let languageCode = SessionStore.getLanguagePreference(deviceHash);
    let localeCode = window.location.hostname.substring(0, 2);
    if (!languageCode) languageCode = localeCode;
    if (!LOCALE_WHITELIST.includes(localeCode)) {
      localeCode = 'en';
    }
    if (!LOCALE_WHITELIST.includes(languageCode)) {
      languageCode = 'en';
    }
    fetchResourceBundle(languageCode)
      .then((resource) => {
        const { translations } = resource;
        Object.assign(resources, {
          [languageCode]: {
            translations: translations,
          },
        });
        callback(languageCode);
      })
      .catch((e) => {
        console.log(e);
        callback(languageCode);
      });
  },
  init: () => {},
  cacheUserLanguage: () => {},
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    /*
     * We init with resources
     */
    resources,
    /*
     * Default fallback is disabled
     * fallbackLng: 'en',
     */
    /*
     * Turn on debug logging if required
     */
    debug: false,
    /*
     * We have a common namespace used around the full app
     */
    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
